import ApolloClient from 'apollo-client'
import Cookies from 'js-cookie'
import { IAppContext } from 'main/framework'

import { CredentialsFields } from 'main/gql/credentials'
import { IUser } from 'main/gql/user/user'
import { consumeContext } from 'main/hooks/useSSOContext'
import { IExchangeCredentials } from 'main/pages/AuthReturnSSO/operations/useExchangeCredentials'
import { logoutPath } from 'main/routes'
import { isInWhitelist } from 'main/util/error'
import WSA from 'sdk/sso'
import logger from 'sdk/sso/utils/logger'

const refreshTokenKey = 'guardian_default_token'

export async function login(
  apolloClient: ApolloClient<{}>,
  credentials: CredentialsFields | IExchangeCredentials,
  context: IAppContext,
) {
  // TODO (alex): Enable after implementing token exchange.
  // TODO (cam): renabled this; investigate Alex B's intentions for token exchange implementation
  localStorage.setItem('access_token', credentials.accessToken)
  localStorage.setItem('refresh_token', credentials.refreshToken)

  // Required for compatibility with other bundles.
  Cookies.set(refreshTokenKey, credentials.refreshToken, {
    expires: 90,
    secure: process.env.NODE_ENV !== 'development',
  })

  const user = { ...credentials.user, sendbirdAccessToken: credentials.sendbirdAccessToken }

  try {
    // Reset apollo store, causing active queries to be refetched.
    await apolloClient.resetStore() // reset first w/ await. all queries complete
    // then set user. otherwise, it complains about modifying an inflight query
  } catch (err) {
    const whitelist = ['Store reset while query was in flight (not completed in link chain)']
    if (!isInWhitelist((err as Error)?.message, whitelist)) {
      logger('Apollo Client resetStore error', err)
    }
  } finally {
    window.lego.user = user as IUser
    // Set user in AppContext
    // @ts-ignore
    context.setUser(user)
  }

  return user as IUser
}

export async function logoutCleanup(isSSO?: boolean) {
  // NOTE (alex): Not currently used. Logout is currently handled by /logout page for backwards
  // compatibility with other bundles (can't clear cookies in JS as they're HTTP-only).
  // TODO (alex): Enable after implementing token exchange.
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')

  if (isSSO) {
    consumeContext()
    await WSA.Auth.signoutLocal()
  }
}

export async function logout(isSSO?: boolean) {
  try {
    await logoutCleanup(isSSO)
  } catch (err) {
    // ignore?
  } finally {
    window.location.assign(logoutPath()) // server side logout and redirect to /logout-complete
  }
}
